import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Splitting from 'splitting';

gsap.registerPlugin(ScrollTrigger);

class Vision {
  constructor(el) {
    this.$container = $(el);
    this.$copy = this.$container.find('.vision__copy');
    this.$media = this.$container.find('.vision__media');

    this.init();
  }

  init() {
    // split words
    Splitting({ target: this.$copy[0], by: 'words' });

    // animate words
    this.$words = this.$copy.find('p > span');
    this.words = gsap.utils.toArray(this.$words);
    this.copyTL = gsap.from(this.words, {
      color: '#575756',
      stagger: 0.2,
      scrollTrigger: {
        trigger: this.$copy[0],
        start: 'top 60%',
        end: 'bottom center',
        scrub: true,
      },
    });
  }
}

export default Vision;
